import hotkeys from 'hotkeys-js'

hotkeys.filter = function (event) {
  const tagName = (event.target || event.srcElement).tagName
  hotkeys.setScope(
    /^(INPUT|TEXTAREA|SELECT)$/.test(tagName) ? 'input' : 'other'
  )
  return true
}

function isMac() {
  return navigator.userAgent.toLowerCase().indexOf('mac') > 0
}

const ctrl = isMac() ? '⌘' : 'ctrl'

hotkeys(`${ctrl}+s`, 'input', function (event, handler) {
  console.log(handler.key)
  event.preventDefault()
  const button = document.querySelector('#js-shortcut-wip')
  if (button) {
    button.click()
  }
})

hotkeys(`${ctrl}+enter`, 'input', function (event, handler) {
  // console.log(handler.key)
  event.preventDefault()

  // 今入力しているテキストエリアを取得
  const textarea = document.activeElement
  if (!textarea || textarea.tagName !== 'TEXTAREA') return

  // テキストエリアとボタンを共通で囲んでいる「親」を探す
  const container = textarea.closest('.thread-comment-form__form.a-card, .thread-comment-form__form, .chats-content-body')

  if (container) {
    // その親の中に含まれるボタンだけを探す
    const button = container.querySelector(
      '#js-shortcut-submit,#js-shortcut-post-comment'
    )
    if (button) {
      button.click()
    }
  }
})

hotkeys(`${ctrl}+e`, 'all', function (event, handler) {
  console.log(handler.key)
  event.preventDefault()
  const button = document.querySelector('#js-shortcut-edit')
  if (button) {
    button.click()
  }
})

hotkeys(`${ctrl}+b`, 'all', function (event, handler) {
  console.log(handler.key)
  event.preventDefault()
  const button = document.querySelector('#js-shortcut-check')
  if (button) {
    button.click()
  }

  const allOpenButton = document.querySelector(
    '#js-shortcut-unconfirmed-links-open'
  )
  if (allOpenButton) {
    allOpenButton.click()
  }
})
